import { useQuery } from "@apollo/client";
import { CURRENT_COHORT_YEAR } from "@/api/queries/currentCohortYear";
import type {
  CurrentCohortYearQuery,
  CurrentCohortYearQueryVariables,
} from "@/__generated__/graphql";

export const useCurrentCohortYear = () => {
  const { data, loading, error } = useQuery<
    CurrentCohortYearQuery,
    CurrentCohortYearQueryVariables
  >(CURRENT_COHORT_YEAR);

  const cohortYear = data?.currentCohortYear;
  const prevCohortYear = cohortYear !== undefined ? cohortYear - 1 : undefined;

  return { cohortYear, prevCohortYear, loading, error };
};
